<template>
  <div class="bg-page">
    <van-form @submit="onSubmit">
      <div class="x-input-no m-top-25">
        <van-field v-model="form.phone" type="tel" placeholder="请输入手机号" :rules="[{ required: true, message: '' }]" :readonly="isEdit">
          <template #right-icon>
            <span v-if="isCode==1" class="x-font-color" @click="getCOde()">获取验证码</span>
            <span v-else-if="isCode==2" class="x-font-color" @click="getCOde()">重新获取验证码</span>
            <van-count-down v-else-if="isCode==3" ref="countDown" :time="time" format="ss 秒" :auto-start="false" @finish="finish" />
          </template>
        </van-field>
      </div>
      <div class="x-input-no m-top-25">
        <van-field v-model="form.code" type="number" placeholder="请输入短信验证码" :rules="[{ required: true, message: '' }]"/>
      </div>
      <div class="x-flex-between">
        <van-button block class="x-btn-log m-btn" native-type="submit">
          下 一 步
          <van-icon class="m-ice" name="down" />
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    components: {},
    computed: {
      ...mapGetters({
        USER_INFO: 'user/userInfo'
      })
    },
    data () {
      return {
        form:{
          phone:'',
          code:'',
        },
        isCode:1,
        time:60000,
        isEdit:false
      }
    },
    created () {

    },
    methods: {
      onSubmit(){
        let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if(!reg.test(this.form.phone)){
          this.utils.toastNone('手机号格式不正确！')
          return
        }
        this.http.postRequest({
          url:'app/userInfo/verifyResetCode',
          msg:{
            phone: this.form.phone,
            code: this.form.code,
          },
          success:(res)=>{
            this.$emit('isOK',2)
          }
        },true)
      },
      getCOde(){
        let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if(!this.form.phone){
          this.utils.toastNone('手机号不能为空！')
          return
        }
        if(!reg.test(this.form.phone)){
          this.utils.toastNone('手机号格式不正确！')
          return
        }
        this.http.postRequest({
          url:'app/userInfo/getResetCode',
          msg:{phone:this.form.phone},
          success:(res)=>{
            if(res.code==200){
              this.utils.toastNone(res.msg)
              this.time = 60000
              this.isCode = 3
              this.$nextTick(()=>{
                this.$refs.countDown.start();
              })
            }
          }
        })
      },
      finish(){
        this.$refs.countDown.reset();
        this.isCode = 2
      }
    },
    mounted () {
      if(this.$route.query.isEdit){
        this.form.phone = this.USER_INFO.phone
        this.isEdit = true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .m-top-25{
    margin-top: 25px;
  }
  .m-btn{
    width: 210px;
    margin: 63px auto 0 auto;
  }
  .m-ice{
    transform: rotate(-90deg);
  }
</style>

